'use client';

import { createContext, useContext } from 'react';
import type { Collection } from '@frameio/graphql-client/generated';

type CollectionId = Collection['id'] | undefined;

export const IsolatedActiveCollectionIdContext =
  createContext<CollectionId>(undefined);

export const useActiveCollectionId = () =>
  useContext(IsolatedActiveCollectionIdContext);

type IsolatedActiveCollectionContextProviderProps = {
  children: React.ReactNode;
  collectionId?: CollectionId;
};

export const IsolatedActiveCollectionIdContextProvider = ({
  collectionId,
  children,
}: IsolatedActiveCollectionContextProviderProps) => {
  return (
    <IsolatedActiveCollectionIdContext.Provider value={collectionId}>
      {children}
    </IsolatedActiveCollectionIdContext.Provider>
  );
};
